import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=13796a44&scoped=true&"
import script from "./Request.vue?vue&type=script&lang=ts&"
export * from "./Request.vue?vue&type=script&lang=ts&"
import style0 from "./Request.vue?vue&type=style&index=0&id=13796a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13796a44",
  null
  
)

export default component.exports